import { PORTAL_URL } from 'constants/common';

// Detecta si la app corre embebida dentro del portal (ruta /app/* del portal).
// Estrategia (ver plan D2):
//  1. Param explícito `?embedded=true` (lo añade el iframe del portal), persistido
//     en sessionStorage para sobrevivir a la navegación SPA interna.
//  2. Fallback: estamos en un iframe cuyo ancestro es el origen del portal.
//     `ancestorOrigins` no existe en Firefox -> ahí solo cuenta el param/sessionStorage.
// No se usa solo `self !== top` porque la app también se renderiza en iframes de
// preview del CMS (previewMode), que NO deben tratarse como modo embedded.
const STORAGE_KEY = 'mls-embedded';

export const isEmbedded = () => {
  if (typeof window === 'undefined') return false;

  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('embedded') === 'true') {
      window.sessionStorage.setItem(STORAGE_KEY, 'true');
      return true;
    }
    if (window.sessionStorage.getItem(STORAGE_KEY) === 'true') {
      return true;
    }
  } catch (error) {
    /* sessionStorage no disponible */
  }

  try {
    if (window.self !== window.top) {
      const ancestors = window.location.ancestorOrigins;
      if (ancestors && ancestors.length) {
        const portalOrigin = new URL(PORTAL_URL).origin;
        return Array.from(ancestors).includes(portalOrigin);
      }
    }
  } catch (error) {
    /* acceso cross-origin bloqueado -> no podemos confirmar, tratamos como no-embedded */
  }

  return false;
};

export default isEmbedded;
